// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ServiceCardsSection_wrapper__G67rl"};